/*!
* @Author: leo
* @Date: 2019-12-24 16:44:00
* @Last Modified by: leo
* @Last Modified time: 2019-12-24 16:44:00
* @Instruduction: 通用配置信息
*/

interface ISettings {
    title: string // Overrides the default title
}
  
// You can customize below settings :)
const settings: ISettings = {
    title: '庖丁'
}
  
export default settings
  